import styled from 'styled-components';
import { media } from 'style-utils';

export const ControllersContainer = styled.div`
  margin-bottom: 10px;
  position: relative;

  ${media.mobileTablet`
    display: flex;
  `}
`;
export const GridContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;
export const ReportingPeriods = styled.div`
  display: inline-block;
  width: 250px;

  ${media.mobileTablet`
    display: block;
    width: 230px;
  `}
`;

export const FilterTabs = styled.div``;

export const Tab = styled.section`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  margin: 0 4px;
  background: ${props =>
    props.selected ? props.theme.color.secondary : props.theme.color.border};
  font-size: 12px;
  color: ${props =>
    props.selected ? props.theme.color.white : props.theme.color.base2};
  cursor: pointer;
  padding: 10px;
  margin-top: 2px;
`;

export const FilterGroupHeader = styled.div`
  display: block;
  color: ${props => props.theme.color.secondary};
  font-family: ${props => props.theme.font.bold};

  ${media.mobileTablet`
  `}

  ${media.desktop`
    float: left;
    margin-right: 10px;
  `}
`;

export const ViewBySpan = styled.span`
  margin: 10px;
`;

export const ContainerTop = styled.div`
  padding: 20px 60px;
  padding-top: 10%;
  max-width: 100%;

  ${media.mobile`
    padding: 0;
    padding-top: 50px;
  `}

  ${media.desktop`
    padding:10px 0 0;
  `}
`;

export const ExportDiv = styled.div`
  display: block;
  position: absolute;
  right: 0;
  top: 10px;
  cursor: pointer;

  & > i {
    padding-right: 10px;
    font-size: 18px;
  }
`;
export const ExportDivEmpty = styled.div`
  display: block;
  position: absolute;
  right: 0;
  top: 10px;
  cursor: pointer;
  padding-right: 150px;
  width: 120px !important;
`;

export const ExportDivContainer = styled.div`
  display: block;
  cursor: pointer;

  ${media.desktop`
    position: absolute;
    right: 0;
    top: 10px;
    padding-right: 10px;
  `}

  ${media.mobileTablet`
    position: relative;
    margin: 0;
  `}

  & > i {
    padding-right: 10px;
    font-size: 18px;
  }
`;

export const ExportFBTDiv = styled.div`
  display: block;
  right: 0;
  top: 10px;
  cursor: pointer;

  ${media.desktop`
    float: left;
    padding-right: 20px;
    cursor: pointer;
  `}

  & > i {
    padding-right: 10px;
    font-size: 18px;
  }

  ${media.mobileTablet`
    position: absolute;
    display: flex;
    align-content: middle;
    top: 0;
    bottom: 10px;
    right: 0;
    cursor: pointer;
  `}
`;



// WEBPACK FOOTER //
// ./src/features/insights/styled.js